@for (shape of definition().shapes; track $index) {
  <svg:path
    [attr.d]="shape.d"
    [attr.fill-rule]="shape.fillRule"
    [attr.clip-rule]="shape.clipRule"
    [attr.fill]="shape.fill" />
}
